export default __webpack_public_path__ + "static/media/bg_TR_BL_d.68b8b15a.png";